/**
 * Opciones disponibles para el selector de Cuerpo Impresor.
 */
export const CUERPO_IMPRESOR_COUNT = 12;

export const cuerpoImpresorOptions = Object.freeze(
  Array.from({ length: CUERPO_IMPRESOR_COUNT }, (_, i) => ({
    label: i + 1,
    value: i + 1,
  })),
);

export const CLAVES_IMPRESORA = Object.freeze([
  'impresora_flexo_ba',
  'impresora_digital',
  'impresora_digital_plana',
  'impresion_offset',
  'flexo_folder_gluer',
]);

/**
 * @param {Object|null} recursoTipo - RecursoTipo del recurso
 * @returns {boolean}
 */
export function esRecursoImpresora(recursoTipo) {
  return CLAVES_IMPRESORA.includes(recursoTipo?.ClaveInterna);
}

/**
 * Opciones del selector limitadas a la cantidad de cuerpos del recurso.
 * Si `max` no es un entero > 0 se devuelven todas las opciones.
 *
 * @param {number|null} max - CantidadCuerposImpresores del recurso
 * @returns {Array<{label: number, value: number}>}
 */
export function getCuerpoImpresorOptions(max = null) {
  const limite = Number(max);
  if (!Number.isInteger(limite) || limite <= 0) return cuerpoImpresorOptions;
  return Array.from({ length: limite }, (_, i) => ({ label: i + 1, value: i + 1 }));
}

/**
 * Dado un array de materiales/tintas ya existentes, devuelve el siguiente
 * número de cuerpo impresor disponible (el menor que todavía no esté usado).
 * Si todos los cuerpos están ocupados, retorna null.
 *
 * @param {Array} materialesExistentes - Filas actuales de ElementoMateriales
 * @param {number|null} max - CantidadCuerposImpresores del recurso (opcional)
 * @returns {number|null}
 */
export function getNextCuerpoImpresor(materialesExistentes = [], max = null) {
  const usados = new Set(
    materialesExistentes
      .map((m) => Number(m.CuerpoImpresor))
      .filter((n) => Number.isFinite(n) && n > 0),
  );
  for (const { value } of getCuerpoImpresorOptions(max)) {
    if (!usados.has(value)) return value;
  }
  return null;
}
